import { nodeListToArray } from '../helpers/nodeListToArray';

declare global {
    interface Window {
        dataLayer: any;
    }
}

export class addToDataLayer {
    container: HTMLElement;
    items: Array<HTMLElement>;


    constructor(container: HTMLElement) {
        this.container = container;
        this.items = nodeListToArray(this.container.querySelectorAll('[data-panel-item]'));
        this.pushToDataLayer();
    }

    pushToDataLayer() {
        this.items.forEach((item) => {
            item.addEventListener("click", function () {
                // Tab Items
                if (item.classList.contains('tabs-list-item')) {
                    try {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'tabEvent',
                            'tabID': `${item.id}`
                        });
                    }
                    catch (ex) {
                        console.error(ex.Message);
                    }
                }

                // Accordion Items
                let childEl = item.querySelector('.repeatable-item');
                if (childEl && childEl.classList.contains('collapsed')) {
                    try {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'accordionEvent',
                            'tabID': `${item.id}`
                        });
                    }
                    catch (ex) {
                        console.error(ex.Message);
                    }

                }
            });
        })
    }
}